module.exports = __webpack_public_path__ + "src/assets/img/antispam.bcf03910.jpg";